import { Component, Vue, Watch } from 'vue-property-decorator';
import ModalItem from '../components/modal/Modal';
import VueEvent from '../utils/Event';

@Component({
  components: { ModalItem }
})
export default class VMModals extends Vue {
  public teacherQuote = '';
  private modalsCounter = 0;
  private modalId: string | null = null;
  private lastScrollTop = window.scrollY;

  mounted() {
    VueEvent.listen('openModal', id => {
      this.modalId = id;
    });
  }

  @Watch('modalId')
  onModalIdChanged(val: string, oldVal: string): void {
    if (val != null) {
      this.lastScrollTop = window.scrollY;
      this.$nextTick(() => {
        document.body.classList.add('site--modal-open');
      });
    } else {
      document.body.classList.remove('site--modal-open');
      this.$nextTick(() => {
        document.documentElement.scrollTop = this.lastScrollTop;
        document.body.scrollTop = this.lastScrollTop;
      });
    }
  }
}
